module.exports = __webpack_public_path__ + "b33fe0658625d493f910bd5d789784e8.svg";